// import axios
import axios, { AxiosResponse } from 'axios';

// import endpoints
import { ORGANIZATIONAL_UNIT_CHILDREN } from 'RestAPIs/endpoints';

// import enums
import { LinkMode } from './LinkPlanUnitForm.types';

// import utils
import dayjs from 'dayjs';

const referenceDate = dayjs().startOf('day').toISOString();

export const getOrganizationalUnits = async (
  brId: number,
  linkMode: LinkMode
) => {
  return await axios
    .get<string[], AxiosResponse<string[]>>(ORGANIZATIONAL_UNIT_CHILDREN, {
      params: {
        organizationalUnitId: brId,
        referenceDate: referenceDate,
        includeAllChildren: linkMode === 'PLAN_UNIT_AND_ALL_OF_ITS_CHILDREN'
      }
    })
    .then(({ data }) => data);
};
export const getOrganizationalUnitsWithoutAllChildren = async (
  brId: number,
  oldReferenceDate?: Date
) => {
  return await axios
    .get<string[], AxiosResponse<string[]>>(ORGANIZATIONAL_UNIT_CHILDREN, {
      params: {
        organizationalUnitId: brId,
        referenceDate: oldReferenceDate ?? referenceDate,
        includeAllChildren: false
      }
    })
    .then(({ data }) => {
      return data;
    });
};
